import { dataHooks } from '@wix/data-hooks'

export const storesFunnelChooseCategoryDataHooks = dataHooks<{
  back: {}
  skip: {}
  next: {}
  stepProgressBar: {}
  title: {}
  subtitle: {}
  categoryItem: { key: string }
  categoryIcon: { key: string }
  categoryTitle: { key: string }
  categoryArrow: { key: string }
}>('stores-funnel-choose-category')
